export default [
  {"value":"Jr.","id":1},
  {"value":"Sr.","id":2},
  {"value":"II","id":3},
  {"value":"III","id":4},
  {"value":"IV","id":5},
  {"value":"V","id":6},
  {"value":"J.D.","id":7},
  {"value":"M.D.","id":8}
];